import React from 'react';

import {observer} from 'mobx-react';
import Checkbox from '@mui/material/Checkbox';
import {IconButton, TableCell, TableRow} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import TimelineIcon from '@mui/icons-material/Timeline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import EllipsisContainer from '../../Shared/EllipsisContainer';

const ROW_INDENT = 16;
const ARROW_SIZE = 18;

export const FolderRow = observer(({folder, depth, isExpanded, checkboxState, onToggleExpand, onToggleCheck}) => (
    <div
        className="flex items-center gap-1 py-1 px-2 rounded-menu hover:bg-panels-normal cursor-pointer"
        style={{marginLeft: `${depth * ROW_INDENT}px`}}
        onClick={onToggleExpand}
    >
        {isExpanded
            ? <KeyboardArrowDownIcon style={{fontSize: ARROW_SIZE}} className="text-main-hover" />
            : <KeyboardArrowRightIcon style={{fontSize: ARROW_SIZE}} className="text-main-hover" />
        }
        <Checkbox
            size="small"
            checked={checkboxState === 'checked'}
            indeterminate={checkboxState === 'indeterminate'}
            onClick={(e) => { e.stopPropagation(); onToggleCheck(); }}
            style={{padding: 2}}
        />
        <FolderOutlinedIcon style={{fontSize: 18}} className="text-classic-button-normal" />
        <span className="text-sm text-main-normal truncate">{folder.name}</span>
    </div>
));

export const ItemRow = observer(({item, depth, isChecked, onToggle}) => (
    <div
        className="flex items-center gap-1 py-1 px-2 rounded-menu hover:bg-panels-normal cursor-pointer"
        style={{marginLeft: `${depth * ROW_INDENT}px`}}
        onClick={onToggle}
    >
        <span style={{width: ARROW_SIZE, flexShrink: 0}} />
        <Checkbox size="small" checked={isChecked} style={{padding: 2}} />
        <TimelineIcon style={{fontSize: 16}} className="text-main-hover" />
        <span className="text-sm text-main-normal truncate">{item.name}</span>
    </div>
));

const cellSx = {borderColor: 'var(--panels-normal-color)'};

export const ModelRow = ({model, connectedCount, totalCount, proceduresLabel, onEdit}) => (
    <TableRow>
        <TableCell sx={cellSx}>
            <EllipsisContainer value={model.ProcedureName}><div>{model.ProcedureName}</div></EllipsisContainer>
        </TableCell>
        <TableCell sx={cellSx}>
            <div className="flex items-center gap-1">
                <span>{connectedCount} / {totalCount} {proceduresLabel}</span>
                <IconButton size="small" onClick={onEdit}>
                    <EditOutlinedIcon fontSize="small" className="text-main-hover" />
                </IconButton>
            </div>
        </TableCell>
    </TableRow>
);
